import { AcademicCap } from '@components/common/icons/custom-icons'
import { FastlyImage } from '@components/common/image'
import { COURSE_QUIZZES } from '@lib/data/course-landing-page'
import { QUIZZES_IMAGE_PATH } from '@lib/constants/quizzes'

const IMAGE_PATH = '/images/courses/'

type Props = {
  courseName: string
}

const CourseQuizzes = ({ courseName }: Props) => {
  const quizzes = COURSE_QUIZZES[courseName]

  return (
    <div className="my-10 lg:px-3 py-5 flex flex-col text-grey">
      <h2 className="text-2xl font-600 leading-tight mb-8">
        {quizzes.heading}
      </h2>
      <div className="grid sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3 self-center">
        {quizzes.contents.map((quiz, i) => (
          <div
            key={i}
            className="flex flex-col bg-white rounded-md border border-white hover:border-orange shadow hover:shadow-md duration-200 cursor-pointer"
          >
            <div className="relative flex-shrink-0">
              <div className="relative w-full">
                <FastlyImage
                  src={`${IMAGE_PATH}${quiz.image.name}.png`}
                  webpSrc={`${IMAGE_PATH}${quiz.image.name}.webp`}
                  alt={quiz.image.alt}
                  layout="fill"
                  className="rounded-t-md object-cover w-full h-56"
                />
              </div>
              <p className="bg-white rounded-t-md mx-6 px-2 absolute bottom-0 left-0">
                Q: {quiz.totalProblems}
              </p>
            </div>
            <div className="flex flex-col h-full items-start p-8 space-y-2">
              <h3 className="text-lg font-600">{quiz.title}</h3>
              <div className="flex space-x-1 items-center flex-wrap text-sm">
                <p className="bg-grey-200 border border-grey-400 rounded-md px-2 mb-1">
                  {quiz.tag}
                </p>
              </div>
              <div className="flex-1 flex flex-col justify-end space-y-2">
                <div className="flex items-center space-x-2">
                  <AcademicCap className="w-5 stroke-0 text-grey-800" />
                  <span>Grade: </span>
                  <span className="whitespace-no-wrap">{quiz.grade}</span>
                </div>
                <div className="flex space-x-2">
                  <FastlyImage
                    width={16}
                    height={24}
                    src={`${QUIZZES_IMAGE_PATH}${quiz.level.toLowerCase()}-level.svg`}
                    alt={`${quiz.level} Level`}
                  />
                  <span>{quiz.level} level</span>
                </div>
              </div>
              <a
                href={quiz.link}
                className="btn text-orange hover:bg-orange-200 active:bg-orange-300 w-full text-center"
              >
                Play now
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
export default CourseQuizzes
